<template>
  <div
    @click="childclick"
    class="el-icon-arrow-down extend"
    v-bind:class="[isExtend ? 'el-icon-arrow-up' : 'el-icon-arrow-down']"
  >
    {{isExtend?'收起':'展开'}}
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
        isExtend:false
    };
  },
  created() {},
  mounted() {},
  methods: {
    childclick() {
        this.isExtend=!this.isExtend;
        this.$emit('click');
    }
  }
};
</script>
<style lang="scss" scoped>
.extend{
    height: 29px;
    padding: 7px 15px;
    font-size: 14px;
    color: #1890ff;
    cursor: pointer;
}
</style>